export const data = [
  {
    "question": "You’ve got a full tank and an open road, what do you do?",
    "option1": "Hit the gas and enjoy every second of speed",
    "option2": "Accelerate confidently and take the lead",
    "option3": "Cruise a little faster than usual, just for fun",
    "option4": "Settle into a smooth, relaxing pace",
    "option5": "Stick to the plan and watch your mirrors",
    "option6": "Set cruise control and follow the speed limit"
  },
  {
    "question": "It’s Saturday and you’re free — what’s your ideal day?",
    "option1": "Taking the car out for a fast, scenic drive",
    "option2": "Doing something spontaneous and exciting",
    "option3": "Cruising around with no set plans",
    "option4": "Spending time in nature or on a casual drive",
    "option5": "Catching up on errands or a few home projects",
    "option6": "Relaxing at home with a good book or show"
  },
  {
    "question": "How would you describe your driving personality?",
    "option1": "Aggressive and fast - I like to push limits",
    "option2": "Confident and instinctive - I trust my gut",
    "option3": "Flexible and alert - I adjust to the moment",
    "option4": "Calm and steady - I keep things smooth",
    "option5": "Focused and efficient - I avoid surprises",
    "option6": "Predictable and careful - I stick to routines"
  },
  {
    "question": "At a party, you're most likely to...",
    "option1": "Be the center of attention with energy to spare",
    "option2": "Keep the vibe going and bring excitement",
    "option3": "Be up for whatever and go with the flow",
    "option4": "Hang back and enjoy the moment quietly",
    "option5": "Help out and make sure things are going well",
    "option6": "Keep things organized and make sure everyone’s comfortable"
  },
  {
    "question": "How do you handle money and spending?",
    "option1": "Spend freely on fun without thinking too much",
    "option2": "If I want it I get it, and I’ll figure it out later",
    "option3": "I treat myself sometimes, but try to be smart",
    "option4": "I look for comfort and value in what I buy",
    "option5": "I save first, spend with a purpose",
    "option6": "I focus on practical, reliable purchases only"
  },
  {
    "question": "Which phrase fits your general mindset?",
    "option1": "Life’s better in the fast lane",
    "option2": "Push limits and see what happens",
    "option3": "Go with the flow, but stay sharp",
    "option4": "Steady and smooth wins the day",
    "option5": "Make smart choices and keep moving forward",
    "option6": "Keep it simple, safe, and reliable"
  },
  {
    "question": "What's usually playing in your car?",
    "option1": "High-energy music that gets my heart racing",
    "option2": "Loud beats with deep bass",
    "option3": "Upbeat tunes or feel-good road trip music",
    "option4": "Something calm like jazz or soft rock",
    "option5": "Podcasts or chill background music",
    "option6": "A little of everything—whatever fits the mood"
  },
  {
    "question": "How does your driving change when you're stressed?",
    "option1": "I drive much faster. They better get out of my way",
    "option2": "I speed up a bit and take corners with more energy",
    "option3": "I stay focused but find driving helps me decompress",
    "option4": "I slow down and drive more cautiously than usual",
    "option5": "I try to avoid driving if I’m feeling off",
    "option6": "I’d rather let someone else take the wheel"
  },
  {
    "question": "If you could own a car from any era, which would it be?",
    "option1": "1990s - raw driving feel, no distractions",
    "option2": "2000s - manuals, turbos, and fun performance",
    "option3": "2010s - good mix of speed and comfort",
    "option4": "2020s - tech, electric, and smart features",
    "option5": "2030s - efficient, automated, and eco-friendly",
    "option6": "2040s/50s - fully self-driving and built for convenience"
  },
  {
    "question": "You get the chance to drive your dream car in Monaco—what’s the move?",
    "option1": "Rip through the winding streets like it’s race day - engine roaring, tires gripping",
    "option2": "Take the scenic mountain roads to really feel the car work",
    "option3": "Cruise the coast with style - windows down, sun out, no rush",
    "option4": "Drive through the city, check out the sights, stay chill",
    "option5": "Use it to get around comfortably — easy parking and AC are key",
    "option6": "Skip the drive - enjoy Monaco by foot or yacht"
  },
  {
    "question": "What's your dream home like?",
    "option1": "A sleek city penthouse with a garage full of toys",
    "option2": "A modern smart home with built-in tech",
    "option3": "A converted loft with space for cool gear",
    "option4": "A cozy cabin away from the noise",
    "option5": "A comfortable home in a quiet neighborhood",
    "option6": "A classic house with a driveway made for car seats and groceries"
  },
  {
    "question": "When you see a long, empty stretch of road, you",
    "option1": "Drop a gear and go all out",
    "option2": "Speed up and enjoy the power",
    "option3": "Pick up the pace and enjoy the view",
    "option4": "Keep it smooth and steady",
    "option5": "Stay focused and keep things safe",
    "option6": "Stick to the rules and cruise along carefully"
  },
  {
    "question": "What matters most to you in a car?",
    "option1": "Maximum performance and speed",
    "option2": "Precise handling and responsiveness",
    "option3": "Balanced looks and daily usability",
    "option4": "Comfort for long drives or passengers",
    "option5": "Efficiency and low upkeep",
    "option6": "Practicality, space, and reliability"
  },
  {
    "question": "What kind of movies are your go-to?",
    "option1": "Fast-paced action with car chases",
    "option2": "Dark thrillers or intense suspense",
    "option3": "Stylish indie or offbeat films",
    "option4": "Dramas with strong storytelling",
    "option5": "Emotional or thoughtful stories",
    "option6": "Comedies and feel-good family movies"
  },
  {
    "question": "What do you really want in a car?",
    "option1": "Raw speed and excitement",
    "option2": "Control and quick response",
    "option3": "Something sporty but usable every day",
    "option4": "Comfort and quiet inside",
    "option5": "Low cost and easy maintenance",
    "option6": "Roomy, safe, and built to last"
  },
  {
    "question": "If your car could have a superpower, what would it be?",
    "option1": "Unlimited top speed - no limits, no rules",
    "option2": "Turbo boost - instant acceleration when I want it",
    "option3": "Adaptive drive - smooth on any surface or condition",
    "option4": "Self-driving with all the comfort features",
    "option5": "Flying - traffic is officially canceled",
    "option6": "Teleportation - skip the drive completely"
  }
]